import React, { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllPermissions } from "../../../redux/slice/getAllPermissionListSlice";
import InfoIcon from "../../../assets/img/info-icon.png";
import { useHasPermission } from "../../../hooks/useHasPermission";

function PermissionUserList() {
    const dispatch = useDispatch();
    const { permissions, status } = useSelector(state => state.Permissions);
    const canView = useHasPermission("Permission-view");

    useEffect(() => {
        if (canView) {
            dispatch(fetchAllPermissions());
        }
    }, [dispatch, canView]);

    if (!canView) {
        return <p className="perm-msg">You don’t have access to view permission list</p>;
    }

    const renderTooltip = (props, description) => (
        <Tooltip id="button-tooltip" {...props}>
            {description}
        </Tooltip>
    );

    return (
        <div className="permission-container">
            <div className="role-data table-responsive">
                {status === 'loading' && (
                    <p className="loading">Loading...</p>
                )}

                {status === 'failed' && (
                    <p className="server-error-msg">Unable to connect to server</p>
                )}
                {status === 'succeeded' && (
                    permissions.length === 0 ? (
                        <p className="loading">No record found for permissions</p>
                    ) : (
                        <table className="role-data-table table table-hover table-vcenter text-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th className="table-row">S.NO.</th>
                                    <th className="table-row">PERMISSIONS</th>
                                    <th className="table-row">TEAM MEMBERS</th>
                                    {/* <th className="table-row">ACTIONS</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {permissions?.map((perm, index) => (
                                    <tr key={perm.id}>
                                        <td className="roleIcon">{index + 1}.
                                        </td>
                                        <td className="rolename">
                                            {perm.name}

                                            <OverlayTrigger
                                                placement="right"
                                                overlay={(props) => renderTooltip(props, perm.description)}>
                                                <img className="rolename-info" src={InfoIcon} alt="role info" />
                                            </OverlayTrigger>
                                        </td>
                                        <td>{perm.userDtos.length} {perm.userDtos.length === 1 ? "Person" : "Persons"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )
                )}
            </div>
        </div>
    );
}

export default PermissionUserList;
